import React, { useEffect, useState } from 'react';

import SearchRetailersFeatured from '../../searches/SearchRetailersFeatured';
import LoadingArea from '@molecules/LoadingArea';
import PopoverSelectEventsForViewer from '@molecules/PopoverSelectEventsForViewer';
import { BodyLarge, DivWithShadowMediumUp, H4 } from '@styled';
import useViewerEvents from '@hooks/useViewerEvents';

const RetailersFeatured = () => {
    const [filterString, setFilterString] = useState();
    const [selectedEvent, setSelectedEvent] = useState();
    const { data: viewerEvents } = useViewerEvents({ futureOnly: true });

    useEffect(() => {
        if (!viewerEvents || selectedEvent) {
            return;
        }

        setSelectedEvent(viewerEvents[0]);
    }, [viewerEvents, selectedEvent]);

    useEffect(() => {
        if (!selectedEvent) {
            return;
        }

        setFilterString(`status:Active AND business_type:Retailer/Tenant AND events_attended:${selectedEvent.code}`);
    }, [selectedEvent]);

    if (!filterString) {
        return <LoadingArea />;
    }

    return (
        <div>
            <H4 className="mb-1.5rem">Retailers Attending Your Events</H4>

            <DivWithShadowMediumUp>
                <div className="align-items-start d-block d-md-flex justify-content-between mb-2rem">
                    <BodyLarge className="pr-1.75rem">Click a retailer to view attendees at your events</BodyLarge>

                    <div className="d-block d-md-flex pt-0.25rem">
                        <PopoverSelectEventsForViewer selectedEvent={selectedEvent} onSelect={setSelectedEvent} />
                    </div>
                </div>

                <SearchRetailersFeatured
                    displayPagingToolbar
                    selectedEvent={selectedEvent}
                    filterString={filterString}
                />
            </DivWithShadowMediumUp>
        </div>
    );
};

export default RetailersFeatured;
